<template>
  <div id="groupOrder">
    <div class="lv3Text container t">填写订单信息</div>
    <div class="box container">
      <div align="right" style="padding:10px 20px 0 0; ">
        <router-link to="/user/address/0">
          <el-button type="text" size="small">
            <i class="fas fa-edit"></i> 管理收货地址
          </el-button>
        </router-link>
      </div>
      <div class="lv2Text box2">
        <div v-if="_.size(addressList)>0">
          <el-row>
            <el-col :span="12">
              <div class="r1">
                <span class="lv3Text l1">收件人：</span>
                <span>{{address.name}}</span>
              </div>
              <div class="r1">
                <span class="lv3Text l1">联系电话：</span>
                <span>{{address.mobile}}</span>
              </div>
              <div class="r1">
                <span class="lv3Text l1">收货地址：</span>
                <span>{{address.province+" "+address.city+" "+address.area}}</span>
                <div style="margin-left:80px;margin-top:5px;">{{address.address}}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-popover placement="bottom-end" width="600" trigger="click" v-model="v">
                  <div>
                    <div v-for="(item,index) of addressList" :key="index">
                      <div style="border-bottom:1px solid #ddd;margin-bottom:10px;">
                        <el-row>
                          <el-col :span="21">
                            <div>
                              <div style="margin-bottom:10px;">{{item.name}} {{item.mobile}}</div>
                              <div
                                style="margin-bottom:10px;"
                              >{{item.province+" "+item.city+" "+item.area+" "+item.address}}</div>
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <div align="right">
                              <el-button plain size="mini" @click="changeAddress(item.id)">使用</el-button>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <el-button plain size="mini" class="btn1" slot="reference">
                    更改地址
                    <i class="fas fa-caret-down"></i>
                  </el-button>
                </el-popover>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-else class="lv3Text">
          未设置收货地址，去
          <el-link type="primary" @click="addFn() ">添加收货地址</el-link>
        </div>
      </div>
      <div style="padding: 0 20px;margin-bottom:30px">
        <el-table border :data="[data]" style="width: 100%">
          <el-table-column width="80">
            <template slot-scope="scope">
              <el-image
                class="cover"
                :src="serve +scope.row.images"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="商品信息">
            <template slot-scope="scope">
              <div class="lv2Text">{{scope.row.title}}</div>
            </template>
          </el-table-column>
          <el-table-column label="价格" width="90">
            <template slot-scope="scope">
              <div class="lv0Text">&yen;{{scope.row.selling_price}}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="90">
            <template slot-scope="scope">
              <div class="lv3Text">x{{scope.row.number}}</div>
            </template>
          </el-table-column>
          <el-table-column label="小计" width="90">
            <template slot-scope="scope">
              <div class="lv0Text">&yen;{{scope.row.selling_price*scope.row.number}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="lv3Text t2">支付方式</div>
      <div class="box2 lv3Text">
        <div
          class="btn5 lv3Text"
          :class="form.paytype=='1'?'active':''"
          @click="form.paytype=1"
        >在线付款</div>
      </div>
      <div class="lv3Text t2">订单信息</div>
      <div class="lv2Text t3">
        <div>
          <span class="l2">商品总数：</span>
          <span class="l3">{{data.number}}件</span>
        </div>
        <div>
          <span class="l2">商品总价：</span>
          <span class="l3">&yen;{{data.selling_price*data.number}}</span>
        </div>
        <div>
          <span class="l2">运费：</span>
          <span class="l3">&yen;{{data.selling_price*data.number>=500?0:20}}</span>
        </div>
        <div style="font-size:20px;margin-top:20px;margin-bottom:20px">
          <span class="l2">应付总额：</span>
          <span
            class="l3 lv0Text"
          >&yen;{{data.selling_price*data.number>=500?data.selling_price*data.number:((data.selling_price*data.number)+20)}}</span>
        </div>
      </div>
    </div>

    <div style="padding: 30px 0;" class="container" align="right">
      <el-button
        type="primary"
        style="width: 150px;"
        @click="submit"
        :disabled="!form.paytype>0"
      >提交订单</el-button>
    </div>
    <el-dialog title="添加收货地址" :visible.sync="addDialog" width="50%" @closed="handleClose">
      <div>
        <el-row :gutter="40" class="row">
          <el-col :span="12">
            <el-input v-model="addform.name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="addform.a_mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="row">
          <el-col :span="8">
            <el-select v-model="addform.province" placeholder="请选择" @change="change1">
              <el-option
                v-for="(item,index) in sel1"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.city" placeholder="请选择" @change="change2">
              <el-option
                v-for="(item,index) in sel2"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.area" placeholder="请选择">
              <el-option
                v-for="(item,index) in sel3"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-input type="textarea" v-model="addform.address" placeholder="请输入详细地址"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addsubmit" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      data: "",
      address: "",
      addressList: "",
      form: {
        address_id: "",
        invoice_mobile: "15618372651",
        paytype: null
      },
      v: false,
      tableData: {
        title: decodeURIComponent(this.$route.query.title),
        number: this.$route.query.number,
        item_no: this.$route.query.item_no,
        id: this.$route.query.r_id,
        p_id: this.$route.query.id,
        images: this.$route.query.images,
        price: this.$route.query.price
      },
      invoiceV: false,
      selectArr: [],
      InvoiceId: 0,
      iLoading: false,
      addform: {},
      addDialog: false,
      sel1: null,
      sel2: null,
      sel3: null,
      loading: false
    };
  },
  created() {
    this.initData();
  },
  activated() {
    this.initData();
  },
  methods: {
    //
    handleClose() {
      this.addform = {};
    },
    addsubmit() {
      this.loading = true;
      this.addform.mobile = this.$cookies.get("user");
      this.addform.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/member/add_address", {
          params: this.addform
        })
        .then(res => {
          this.addDialog = false;
          this.loading = false;
          if (res.data.status == "success") {
            this.$message({
              message: "添加了一个新的收货地址",
              type: "success"
            });
            this.initData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    change1(v) {
      this.axios.get(this.serve + "/city?name=" + v).then(res => {
        this.sel2 = res.data;
      });
    },
    change2(v) {
      this.axios.get(this.serve +"/area?name=" + v).then(res => {
        this.sel3 = res.data;
      });
    },
    addFn() {
      this.axios.get(this.serve +"/province").then(res => {
        this.sel1 = res.data;
        this.addDialog = true;
      });
    },
    submit() {
      var formdata = new FormData();
      formdata.append("mobile", this.$cookies.get("user"));
      formdata.append("token", this.$cookies.get("token"));
      formdata.append("id", this.data.id);
      formdata.append("address_id", this.address.id);
      formdata.append("pay_type", this.form.paytype);
      formdata.append("product_list", JSON.stringify([this.data]));
      formdata.append("all_money", this.data.selling_price * this.data.number);
      formdata.append(
        "pay_money",
        this.data.selling_price * this.data.number >= 500
          ? this.data.selling_price * this.data.number
          : this.data.selling_price * this.data.number + 20
      );
      for (var pair of formdata.entries()) {
        // console.log(pair[0] + ", " + pair[1]);
      }
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios
        .post(
          this.serve +"/exchange/buy_exchange",
          formdata,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$router.push("/user/pay?order=" + res.data.data);
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },

    changeAddress(i) {
      this.form.address_id = i;
      for (var item of this.addressList) {
        if (item.id == i) {
          this.address = item;
        }
      }
      this.v = false;
    },
    initData() {
      this.axios
        .get(this.serve +"/member/get_default_address2", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.address = res.data.data;
        });

      this.axios
        .get(this.serve +"/member/get_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.addressList = res.data.data.results;
        });
      this.data = JSON.parse(this.$route.query.data);
    }
  }
};
</script>
<style lang="scss">
#groupOrder {
  .row {
    margin-bottom: 20px;
  }
  .l3 {
    display: inline-block;
    width: 80px;
  }
  .t3 {
    padding: 20px;
    line-height: 1.5em;
    text-align: right;
  }
  .hide {
    display: none;
  }
  .s-item {
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 90px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .btn4 {
    cursor: pointer;
    border: 2px solid #e2211c;
    padding: 10px 60px;
    display: inline-block;
    border-radius: 5px;
    color: #e2211c;
    background-color: #f5f5f5;
  }
  .btn5.active {
    border: 2px solid #e2211c;
    color: #e2211c;
  }
  .btn5 {
    cursor: pointer;
    border: 2px solid #ddd;
    padding: 10px 60px;
    display: inline-block;
    border-radius: 5px;
    background-color: #f5f5f5;
    margin: 0 10px;
  }
  .t2 {
    padding: 10px 20px;
  }
  .cover {
    width: 100%;
  }
  .btn1 {
    float: right;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -14px;
  }
  padding-bottom: 50px;
  .r1 {
    margin-bottom: 10px;
  }
  .l1 {
    width: 80px;
    display: inline-block;
  }
  .t {
    padding: 20px 0;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .box2 {
    border: 1px solid #ddd;
    padding: 20px;
    margin: 20px;
  }
}
</style>